import {ActionsPayloads, DistributeRewardActions, DistributeRewardActionTypes, DistributeRewardState} from "./actions"
import {
  defaultAction,
  updateRecipientsList,
  updateRecognition,
  updateRewardImportType,
  updateRewardMessage,
  updateRewardRecipientType,
  updateUserPoints,
  updateErrorState,
  updateBulkRewardState,
  onAcceptEmailErrors,
  onRejectEmailErrors
} from "./helpers"

const ActionsCases = {
  [DistributeRewardActions.SWITCH_RECIPIENT]: updateRewardRecipientType,
  [DistributeRewardActions.SWITCH_IMPORT_TYPE]: updateRewardImportType,
  [DistributeRewardActions.UPDATE_RECIPIENTS]: updateRecipientsList,
  [DistributeRewardActions.SET_USER_POINTS]: updateUserPoints,
  [DistributeRewardActions.SET_MESSAGE]: updateRewardMessage,
  [DistributeRewardActions.SET_RECOGNITION]: updateRecognition,
  [DistributeRewardActions.SET_BULK_REWARD_STATE]: updateBulkRewardState,
  [DistributeRewardActions.SET_MODAL_ERROR_STATE]: updateErrorState,
  [DistributeRewardActions.ON_ACCEPT_EMAIL_ERRORS]: onAcceptEmailErrors,
  [DistributeRewardActions.ON_REJECT_EMAIL_ERRORS]: onRejectEmailErrors
}

const DistributeRewardReducer = (state: DistributeRewardState, action: DistributeRewardActionTypes): DistributeRewardState => {
  const {type, payload} = action
  const actionCase = ActionsCases[type]
  if(!actionCase) {
    return defaultAction(state)
  }
  return actionCase(state, payload as ActionsPayloads)
}

export default DistributeRewardReducer
